export const ordersBasePath = 'commandes';
export const orderDetailPath = ':idOrder';
